module.exports = __webpack_public_path__ + "img/Ca.beb8b64a.png";